import React, { useState } from "react";
import { Eye, EyeOff, Lock, ShieldCheck, User, UserPlus, UsersRound } from "lucide-react";
import { useNavigate,Link } from "react-router-dom";
import { HTTP } from "../api/http-common";
import { isValidEmail } from './../component/common';
import { useGlobalContext } from "./../component/GlobalContext";
import Swal from 'sweetalert2'
 


const VendorLogin = function () {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [emailError, setEmailError] = useState("");
  const [password, setPassword] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [passwordShow, setPasswordShow] = useState(false);
  // const { user, setUser, theme, setTheme, language, setLanguage } = useGlobalContext();
  const { globalUserVar, setGlobalUserVar, setIsAuthenticated } = useGlobalContext();


  const resetValidationErrors = () => {
      setEmailError('');
      setPasswordError('');
  };

  const validateField = () => {
    let checked = true;

    resetValidationErrors();

    if (email === '') {
        setEmailError('Please enter email address');
        checked = false;
    } 
    else if (!isValidEmail(email)) {
        setEmailError('Invalid email.');
        checked = false;
    }

    return checked;
  };
 const hideShowPass = () => {
    setPasswordShow(!passwordShow);
 }
  const handleSubmit = async () => {
    if (validateField()) {
      try {
        // setIsLoading(true);
        // let config = {
        //   headers: { "Content-Type": "application/json", token: access_token },
        // };

        let fields = {
          email: email,
          password: password,
          type: 'vendor',
        };

        await HTTP.post(
          "/user/login",
          fields,
          // config
        )
          .then(async (response) => {
            if (response.status === 200) {
              localStorage.setItem('access_token', response.data.access_token);
              localStorage.setItem('refresh_token', response.data.refresh_token);
              localStorage.setItem('access_token_expires', response.data.access_token_expires)
              fetchUserData()
            }
          })
          .catch((error) => {
            if (error.response.status === 406) {
                resetValidationErrors();
                setPasswordError(error.response.data.detail);
            }
            if (error.response.status === 401) {
              Swal.fire({
                  title: 'Error!',
                  text: 'You are already registered!',
                  icon: 'error',
                  confirmButtonText: 'Ok'
                })
          }
            // setError(error);
            // setRerenderFlag(true);
            // loadAaMasterData();
            // resetValidationErrors();
          });

        // setIsLoading(false);
      } catch (error) {
        // setError(error);
        // setRerenderFlag(true);
        // setIsLoading(false);
      }
    }
  };
  const fetchUserData = () => {
    const access_token = localStorage.getItem('access_token');
    const config = {
        headers: { 'Content-Type': 'application/json', 'token': access_token },
    };
    HTTP.get("user/me", config, config)
        .then((response) => {
            if (response.status === 200) {
                localStorage.setItem('userObj', JSON.stringify(response.data));
                setGlobalUserVar(JSON.stringify(response.data))
                setIsAuthenticated(response.data.email_verified)
                navigate('/coupons');
            }
        })
        .catch((error) => {
            console.log(error);

        });
};

  return (
    <div 
      className="rounded-xl border bg-card text-card-foreground w-full p-8 shadow-sm max-w-[450px] min-h-[450px]"
      // style={{ maxHeight: '580px', height: '100%', overflow: 'scroll' }}
    >
      <div className="flex gap-6 mb-6 mt-4">
        <button className="text-2xl font-semibold">Business Partner Sign in</button>
      </div>
      <div className="flex flex-col gap-8">
        <div className="relative space-y-1">
          <div className="relative space-y-1">
            <input
              className="peer w-full focus:outline-none focus:border-b focus:border-gray-400 peer h-10 px-0 bg-transparent border-0 border-b input-border-bottom rounded-none focus-visible:ring-0 focus-visible:border-gray-400 placeholder:text-gray-400"
              placeholder=" "
              value={email}
              name="username"
              onChange={(e) => {
                setEmail(e.target.value);
              }}
            />
          </div>
          <label className="absolute left-0 -top-2 text-xs text-gray-500 transition-all peer-placeholder-shown:top-2.5 peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-400 peer-focus:-top-2 peer-focus:text-xs peer-focus:text-gray-500">
            Email
          </label>
          {emailError && <span className="text-sm text-red-500">{emailError}</span>}
        </div>
        <div className="relative space-y-1">
          <div className="relative space-y-1">
            <input
              type={passwordShow ? "text" : "password"}
              className="peer w-full focus:outline-none focus:border-b focus:border-gray-400 placeholder:text-gray-400 peer h-10 px-0 bg-transparent border-0 border-b input-border-bottom rounded-none focus-visible:ring-0 focus-visible:border-gray-400"
              placeholder=" "
              value={password}
              name="password"
              onChange={(e) => {
                setPassword(e.target.value);
              }}
            />
          </div>
          <label className="absolute left-0 -top-2 text-xs text-gray-500 transition-all peer-placeholder-shown:top-2.5 peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-400 peer-focus:-top-2 peer-focus:text-xs peer-focus:text-gray-500">
            Password
          </label>
          {passwordError && <span className="text-sm text-red-500">{passwordError}</span>}
          <button type="button" className="absolute right-0 bottom-2 text-gray-400" onClick={hideShowPass}>
            {passwordShow ? <EyeOff className="mr-2 h-4 w-4" /> : <Eye className="mr-2 h-4 w-4" />}
          </button>
        </div>
        <div className="">
          <button
            className="inline-flex items-center justify-center gap-2 whitespace-nowrap text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 [&amp;_svg]:pointer-events-none [&amp;_svg]:size-4 [&amp;_svg]:shrink-0 shadow px-4 py-2 w-full h-8 bg-[#6C38FF] hover:bg-[#5b2ee6] text-white rounded-lg mt-2 login-page-button-wrapper"
            type="submit"
            onClick={handleSubmit}
          >
            <User className="mr-2 h-4 w-4" />
            Sign In
          </button>
        </div>
        
        <div>
            <Link
              to="/forgotpassword"
              className="text-gray-500 hover:text-gray-700 text-sm inline-flex items-center mb-2 seperate-line"
            >
            <Lock className="mr-2 h-4 w-4" />
            Forgot password?
            </Link>
            &nbsp; &nbsp;
            <Link
              to="/verify"
              className="text-gray-500 hover:text-gray-700 text-sm inline-flex items-center"
            >
              <ShieldCheck className="mr-2 h-4 w-4"/>
              Click me to Verify your email
            </Link>


            {/* <Link
              to="/member/register"
              className="text-gray-500 hover:text-gray-700 text-sm inline-flex items-center seperate-line"
            >
            <UsersRound className="mr-2 h-4 w-4"/>
              Member's Sign Up?
            </Link>
            &nbsp; &nbsp; */}
            <Link
              to="/vendor/register"
              className="text-gray-500 hover:text-gray-700 text-sm inline-flex items-center"
            >
              <UserPlus className="mr-2 h-4 w-4" />
              Business Partner Sign Up?
            </Link>
          </div>
      </div>
    </div>
  )
}

export default VendorLogin
